var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"f-l-r m-r-10",attrs:{"type":"success","id":"details2"}},[_vm._v("在线咨询")])
}
var staticRenderFns = []

export { render, staticRenderFns }